import { ICellRendererParams } from "ag-grid-community";
import clsx from "clsx";
import React, { useId } from "react";
import { Tooltip } from "react-tooltip";

export type TCellColorRenderer = {
  className?: string;
  background: string;
  onClick?: () => void;
  tooltip?: string;
};

const CellColorRenderer: React.FC<{
  params: ICellRendererParams;
  custom: TCellColorRenderer;
}> = ({ params, custom: { className, background, onClick, tooltip } }) => {
  const tooltipId = useId();

  return (
    <div className={clsx(["inline-flex", "items-center", "h-full"])}>
      <div
        className={clsx([
          "flex",
          "shrink-0",
          "rounded-md",
          "border",
          "border-gray-200",
          "dark:border-gray-700",
          "h-[30px]",
          "w-[30px]",
          {
            "cursor-pointer": !!onClick,
          },
        ])}
        style={{ background }}
        onClick={() => onClick?.()}
        data-tooltip-id={tooltipId}
        data-tooltip-content={tooltip}
        data-tooltip-position-strategy="fixed"
        data-tooltip-offset={0}
      >
        <Tooltip id={tooltipId} style={{ zIndex: 99 }} />
      </div>
    </div>
  );
};

export default React.memo(CellColorRenderer);
